var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgClock = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 16,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.552 1c-3.858 0-7 3.142-7 7s3.142 7 7 7 7-3.142 7-7-3.142-7-7-7Zm0 1.077A5.916 5.916 0 0 1 14.475 8a5.916 5.916 0 0 1-5.923 5.923A5.916 5.916 0 0 1 2.63 8a5.916 5.916 0 0 1 5.923-5.923Zm-.538 1.077v5.384h3.23V7.462H9.091V3.154H8.014Z",
  fill: "#111"
})));
export default SvgClock;